function Services() {
    return (
        <section>
        <div class="inner">
            <header>
            <h1>Services</h1>
            </header>
            <section class="columns double">
            <div class="column">
                <span class="image left special"><img src="images/menscut.jpg" alt="Men's Cut" /></span>
                <h3>Hair cuts</h3>
                <table>
                <tr>
                    <td>Men's haircut</td>
                    <td>$35.00</td>
                </tr>
                <tr>
                    <td>Women's haircut</td>
                    <td>$65.00</td>
                </tr>
                </table>
            </div>
            <div class="column">
                <h3>Styling</h3>
                <table>
                <tr>
                    <td>Blow-dry</td>
                    <td>$40.00</td>
                </tr>									
                </table>
            </div>
            </section>
            <section class="columns double">
            <div class="column">
                <h3>Technicals</h3>
                <table>
                <tr>
                    <td>Balayage</td>
                    <td>$275.00</td>
                </tr>
                            <tr>
                    <td>Color full highlights and blow-dry</td>
                    <td>$200.00</td>
                </tr>
                <tr>
                    <td>Color partial highlights and blow-dry</td>
                    <td>$170.00</td>
                </tr>
                <tr>
                    <td>Color and blow-dry</td>
                    <td>$120.00</td>
                </tr>
                <tr>
                    <td>Color and cut</td>
                    <td>$135.00</td>
                </tr>
                <tr>
                    <td>Color application</td>
                    <td>$80.00</td>
                </tr>
                <tr>
                    <td>Color full highlights and cut</td>
                    <td>$220.00</td>
                </tr>
                <tr>
                    <td>Color partial highlights and cut</td>
                    <td>$190.00</td>
                </tr>
                <tr>
                    <td>Full highlights and blow-dry</td>
                    <td>$170.00</td>
                </tr>
                <tr>
                    <td>Full highlights and cut</td>
                    <td>$190.00</td>
                </tr>					
                <tr>
                    <td>Men color and cut</td>
                    <td>$100.00</td>
                </tr>
                <tr>
                    <td>Mini highlights and blow-dry</td>
                    <td>$120.00</td>
                </tr>
                <tr>
                    <td>Mini highlights and cut</td>
                    <td>$140.00</td>
                </tr>	
                <tr>
                    <td>Partial highlights and blow-dry</td>
                    <td>$150.00</td>
                </tr>				
                <tr>
                    <td>Partial highlights and cut</td>
                    <td>$170.00</td>
                </tr>
                <tr>
                    <td>Toner</td>
                    <td>$45.00</td>
                </tr>
                </table>
            </div>
            <div class="column">
                <h3>Treatment</h3>
                <table>
                <tr>
                    <td>Hair Treatment</td>
                    <td>$40.00</td>
                </tr>
                <tr>
                    <td>Wella Plex Treatment</td>
                    <td>$40.00</td>
                </tr>
                </table>
            </div>
            <p><strong>Prices subject to change</strong></p>
            </section>
        </div>
    </section>
    );
}

export default Services;
